let current = Date.now();

export const nextId = () => `id--${current++}`;
